export const onPageSelfScheduleInitialValues = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    // Which button was clicked ('schedule' | 'question'), set via setFieldValue
    // in the button's onClick before the real Formik submit runs — mirrors the
    // consult form's consultType pattern.
    intent: '',
};

export default onPageSelfScheduleInitialValues;
